import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { HEADER_NAV_VALUES } from 'enrollment/components/Header/utils';

export interface HeaderState {
  activeHeader: number;
  maxHeaderItem: number;
  headerItems: string[];
  perPayPeriodCost: number;
  isLoadingBenefits: boolean;
}

const initialState: HeaderState = {
  activeHeader: 0,
  maxHeaderItem: 0,
  headerItems: HEADER_NAV_VALUES,
  perPayPeriodCost: 0,
  isLoadingBenefits: true,
};

const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    setActiveHeader: (state, { payload }: PayloadAction<number>) => {
      state.activeHeader = payload;
    },
    setMaxHeaderItem: (state, { payload }: PayloadAction<number>) => {
      state.maxHeaderItem = payload;
    },
    setHeaderItems: (state, { payload }: PayloadAction<string[]>) => {
      state.headerItems = payload;
    },
    setPerPayPeriodCost: (state, { payload }: PayloadAction<number>) => {
      state.perPayPeriodCost = payload;
    },
    setIsLoadingBenefits: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoadingBenefits = payload;
    },
  },
});

const { reducer, actions } = headerSlice;

export const {
  setActiveHeader,
  setMaxHeaderItem,
  setHeaderItems,
  setPerPayPeriodCost,
  setIsLoadingBenefits,
} = actions;

export const headerReducer = reducer;
